import React, { useState } from 'react'

export default function CTAButton() {
    const [isHovered, setIsHovered] = useState(false);


    return (
        <div className='transition-all ease-in-out '>
            <a href="https://app.senangpay.my/payment/174953854759" target='_blank' rel='noreferrer'>
                <button className="w-full h-full aspect-square rounded-full animate-scale linear"
                    style={{
                        animationDuration: "1s",
                        animationPlayState: isHovered ? "paused" : "running",
                    }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <img className='select-none' src="/assets/icon/cta-button-2.svg" alt="" />
                </button>
            </a>
        </div>
    )
}
